import React, { Component } from "react";
import queryString from "query-string";
import _ from "lodash";

import { searchAPI } from "../../api";
import logo from "../../assets/logos/gulftree-logos-final-green.svg";
import "./FilterPrint.sass";

class FilterPrint extends Component {
  state = {
    filters: [],
    isFetching: true,
  };

  componentDidMount() {
    const parsed = queryString.parse(this.props.location.search);

    if (!_.isArray(parsed.id)) {
      console.warn(
        "Query string formatted incorrectly and/or no IDs present in URL"
      );
      this.setState({ isFetching: false });
    } else {
      searchAPI
        .getFilteredSearchFiltersListByIds(parsed.id)
        .then((res) =>
          this.setState({ filters: res.filters, isFetching: false })
        );
    }
  }

  renderFilterTermChildren(child, idx) {
    return (
      <div key={idx} className="filter-print__term-child">
        {child.name}
      </div>
    );
  }

  renderFilterTerm = (term, idx) => {
    return (
      <div key={idx} className="filter-print__term">
        <div>{term.name}</div>
        {term.children && term.children.map(this.renderFilterTermChildren)}
      </div>
    );
  };

  renderFilters = (filters) => {
    return filters.map((filter, idx) => (
      <div key={idx}>
        <div>{filter.filter_name}</div>
        {filter.filter_terms && filter.filter_terms.map(this.renderFilterTerm)}
      </div>
    ));
  };

  render() {
    const { filters, isFetching } = this.state;

    return (
      <div className="filter-print__container">
        <div className="filter-print__print">
          <button
            type="button"
            className="filter-print__print-btn"
            onClick={window.print}
          >
            Print
          </button>
        </div>
        <img className="filter-print__logo" src={logo} alt="Gulf TREE logo" />
        <div className="filter-print__content">
          <h4 className="filter-print__header">List of selected filters</h4>
          <div className="filter-print__filters">
            {filters.length || isFetching ? (
              this.renderFilters(filters)
            ) : (
              <div>No filters selected</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default FilterPrint;
